module.exports = __webpack_public_path__ + "img/pusher_item_2.47ddacb1.png";